module.exports = __webpack_public_path__ + "static/media/lab2-sample-webpage.a6c773ba.png";